var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassportFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 143,
    viewBox: "0 0 126 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#passport_filled_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 25,
    width: 46,
    height: 58,
    rx: 4,
    fill: "#005FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 23.496h29.258l-.007-.05a4 4 0 00-4.515-3.407L44 23.496z",
    fill: "#005FF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 67.688,
    width: 14.25,
    height: 2,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 62.506,
    width: 19.432,
    height: 2,
    rx: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 46a9 9 0 11-18 0 9 9 0 0118 0zm-9 6.9a6.9 6.9 0 100-13.8 6.9 6.9 0 000 13.8z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "passport_filled_svg__filter0_d",
    x: 0,
    y: 0,
    width: 126,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgPassportFilled as ReactComponent };